import React from 'react';
import './App.css';
import { DirectoryApp } from './DirectoryList';

function App() {
  return (
    <div className="App">
      <DirectoryApp />
    </div>
  );
}

export default App;
